import { GET_LIST, GET_MANY, UPDATE } from 'react-admin';
import { providerRoleRequestToHttpRequest } from './roles.dataProvider';

export const NON_PROVIDER_ROLES_RESOURCE_NAME = 'non.provider.roles';

export const providerRequestToHttpRequest = (requestType, requestParams) => {
  // Add meta information for React Admin's cache
  const paramsWithCache = {
    ...requestParams,
    meta: {
      ...requestParams.meta,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: false,
    },
  };
  return providerRoleRequestToHttpRequest(requestType, paramsWithCache, true);
};

const httpResponseToProviderData = (
  httpResponse,
  requestType,
  requestParams,
) => {
  let { headers, json } = httpResponse;
  switch (requestType) {
    case GET_LIST:
      return {
        data: json
          .map((roleItem) => roleItem)
          .filter((roleItem) => roleItem.is_provider_subtype === false),
        total: parseInt(headers.get('content-range').split('/').pop()),
      };
    case GET_MANY:
      let roleIdsToGet = requestParams.ids;
      return {
        data: json
          .filter((roleItem) => roleIdsToGet.includes(roleItem.id))
          .filter((roleItem) => roleItem.is_provider_subtype === false),
      };
    case UPDATE:
      return {
        data: json,
      };
    default:
      return { data: json };
  }
};

export default {
  resource: NON_PROVIDER_ROLES_RESOURCE_NAME,
  providerInterface: {
    providerRequestToHttpRequest,
    httpResponseToProviderData,
  },
};
